import { createFileRoute } from "@tanstack/react-router";
import { FacilitySetupWizard } from "@/components/facilities/wizard/facility-setup-wizard";

// The guided setup wizard owns its page chrome (breadcrumb + title + stepper),
// so the route mounts it directly. It is the only way to create a premise —
// the single-page facility form and the full-page edit route are both gone,
// and post-create changes are made inline on the detail page.
export const Route = createFileRoute("/_authenticated/facilities/new")({
  component: FacilitySetupWizard,
});
